import React, { forwardRef } from 'react';

interface MdlFieldRowProps {
    label: string;
    value?: string;
    /** destaca a linha (ex.: variável mapeada) */
    highlighted?: boolean;
    mono?: boolean;
}

// Linha de campo "label → value" de um card MDL. Expõe ref para o conector
// ancorar a ponta da linha SVG neste ponto exato.
const MdlFieldRow = forwardRef<HTMLDivElement, MdlFieldRowProps>(
    ({ label, value, highlighted = false, mono = true }, ref) => (
        <div
            ref={ref}
            className={`flex items-baseline justify-between gap-3 py-1 px-1 rounded ${
                highlighted ? 'bg-amber-50 ring-1 ring-amber-300' : ''
            }`}
        >
            <span className={`text-[12px] font-semibold text-blue-800 ${mono ? 'font-mono' : ''}`}>
                {label}
            </span>
            {value !== undefined && (
                <span className="text-[12px] text-gray-600 font-mono text-right truncate">{value}</span>
            )}
        </div>
    ),
);

MdlFieldRow.displayName = 'MdlFieldRow';

export default MdlFieldRow;
